var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 1.16667,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2935 10.6741C13.7587 9.73825 12.3696 9.01074 12.3696 7.86713C12.3696 6.89658 13.1681 6.34243 14.592 6.34243C17.1962 6.34243 19.8696 7.34702 21.7101 8.24823L22.7518 1.83768C20.0642 0.600092 17.1351 -0.027228 14.1753 0.000906153C11.2587 0.000906153 8.8279 0.763095 7.09196 2.1841C5.2862 3.67477 4.34875 5.82264 4.34875 8.4216C4.34875 13.1344 7.23094 15.1442 11.9182 16.842C14.9381 17.9162 15.9447 18.6787 15.9447 19.8557C15.9447 20.9993 14.9725 21.6575 13.2015 21.6575C11.0139 21.6575 7.40304 20.5836 5.04169 19.1972L4 25.6784C6.01325 26.822 9.76373 28 13.6529 28C16.7429 28 19.3124 27.2725 21.0486 25.8865C22.993 24.3618 24 22.1096 24 19.1985C24 14.3817 21.0486 12.3719 16.2919 10.6758L16.2935 10.6741Z",
    fill: "#635BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/Stripe.172495bb3232710e0be0fa85c904c142.svg";
export { ForwardRef as ReactComponent };